<sf-product-select [productData]="productData"></sf-product-select>